import type { UserInviteFields } from '~/components/containers/UserManagementContainer/data/UserInvite';
import type { UserFields } from '~/components/containers/UserManagementContainer/data/User';
import BFFAPI from './utils/BFFAPI';

export interface UsersResponse {
  users: UserFields[];
}

export interface InvitesResponse {
  invites: Omit<UserInviteFields, 'resendInvitation'>[];
}

class UserManagementAPI extends BFFAPI {
  getUser = (userId: string): Promise<UserFields> => {
    const req = this.fetchHelper.createGetRequest(
      `${this.endpoint}/users/${userId}`
    );
    return this.fetch(req);
  };

  deleteUser = (userId: string) => {
    const req = this.fetchHelper.createDeleteRequest(
      `${this.endpoint}/users/${userId}`
    );
    return this.fetch(req);
  };

  editUser = (userId: string, roles: string[]) => {
    const req = this.fetchHelper.createPatchRequest(
      `${this.endpoint}/users/${userId}`,
      { roles }
    );
    return this.fetch(req);
  };

  getAvailableRoles = () => {
    const req = this.fetchHelper.createGetRequest(
      `${this.endpoint}/available-roles`
    );
    return this.fetch(req);
  };

  getInvites = (): Promise<InvitesResponse> => {
    const req = this.fetchHelper.createGetRequest(
      `${this.endpoint}/user-invites`
    );
    return this.fetch(req);
  };

  getUsersWithRole = (role = ''): Promise<UsersResponse> => {
    const req = this.fetchHelper.createGetRequest(
      `${this.endpoint}/users/role/${role}`
    );
    return this.fetch(req);
  };

  getAllUsers = (): Promise<UsersResponse> => {
    const req = this.fetchHelper.createGetRequest(`${this.endpoint}/users`);
    return this.fetch(req);
  };

  resendInvitation = (inviteId: string) => {
    const req = this.fetchHelper.createPostRequest(
      `${this.endpoint}/user-invites/${inviteId}/resend`
    );
    return this.fetch(req);
  };

  deleteInvitation = (inviteId: string) => {
    const req = this.fetchHelper.createDeleteRequest(
      `${this.endpoint}/user-invites/${inviteId}`
    );
    return this.fetch(req);
  };

  sendUserInvite = (
    email: string,
    firstName: string,
    lastName: string,
    roles: string[],
    accessGroupIds: string[],
    recaptchaVerification: string | null
  ) => {
    const req = this.fetchHelper.createPostRequest(
      `${this.endpoint}/user-invites/create`,
      {
        email,
        firstName,
        lastName,
        roles,
        accessGroupIds,
        recaptchaVerification,
      }
    );
    return this.fetch(req);
  };
}

export default new UserManagementAPI('/fleet/secure/user-management');
